import React from "react";
import Component from "../../Components";

const DriverProfile = () => {
  return (
    <div>
      <Component.ManageDriverProfile />
    </div>
  );
};

export default DriverProfile;
